import qs from "qs";
import {apiVoissa} from "../../libs/api";


export const fetchForums = (query = {}, config = {}) => apiVoissa.get(`/forums?${qs.stringify(query)}`, config);

export const fetchForumChildrens = (forumId, query = {}, config = {}) => apiVoissa.get(`/forums/${forumId}/childrens?${qs.stringify(query)}`, config);

export const fetchForumBreadcrumbs = (forumId, query = {}, config = {}) => apiVoissa.get(`/forums/${forumId}/breadcrumbs?${qs.stringify(query)}`, config);

export const fetchForumComments = (forumId, topicId, query = {}, config = {}) => apiVoissa.get(`/forums/${forumId}/topics/${topicId}/comments?${qs.stringify(query)}`, config);

export const createForumComment = (forumId, topicId, data, config = {}) => apiVoissa.post(`/forums/${forumId}/topics/${topicId}/comments`, data, config);
export const fetchForumComment = (forumId, topicId, commentId, query = {}, config = {}) => apiVoissa.get(`/forums/${forumId}/topics/${topicId}/comments/${commentId}?${qs.stringify(query)}`, config);

export const updateForumComment = (forumId, topicId, commentId, data, config = {}) => apiVoissa.patch(`/forums/${forumId}/topics/${topicId}/comments/${commentId}`, data, config);
export const deleteForumComment = (forumId, topicId, commentId = {}, config = {}) => apiVoissa.delete(`/forums/${forumId}/topics/${topicId}/comments/${commentId}`, config);

export const reportForumComment = (forumId, topicId, commentId, data = {}, config = {}) => apiVoissa.post(`/forums/${forumId}/topics/${topicId}/comments/${commentId}/reporting`, data, config);

export const fetchForumTopics = function (forumId, query = {}, config = {}) {
    let sort = ['-isPinned,-lastComment.createdAt', '-isPinned,-createdAt', '-isPinned,-count.comment', '-isPinned,-count.view'];
    query = {...query, sort: sort[query.sort] || 0};
    return apiVoissa.get(`/forums/${forumId}/topics?${qs.stringify(query)}`, config);
};

export const updateForumTopic = (forumId, topicId, data = {}, config = {}) => apiVoissa.patch(`/forums/${forumId}/topics/${topicId}`, data, config);
export const moveForumTopic = (forumId, topicId, data = {}, config = {}) => apiVoissa.patch(`/forums/${forumId}/topics/${topicId}/move`, data, config);
export const deleteForumTopic = (forumId, topicId = {}, config = {}) => apiVoissa.delete(`/forums/${forumId}/topics/${topicId}`, config);

export const reportForumTopic = (forumId, topicId, data = {}, config = {}) => apiVoissa.post(`/forums/${forumId}/topics/${topicId}/reporting`, data, config);

export const createFollowForumTopic = (forumId, topicId, query = {}, config = {}) => apiVoissa.post(`/forums/${forumId}/topics/${topicId}/follow?${qs.stringify(query)}`, config);
export const deleteFollowForumTopic = (forumId, topicId, query = {}, config = {}) => apiVoissa.delete(`/forums/${forumId}/topics/${topicId}/follow?${qs.stringify(query)}`,config);


export const fetchListForumsForMoveTopic = (config = {}) => apiVoissa.get(`/forums/list-forums`, config);
export const fetchForumsStats = (config = {}) => apiVoissa.get(`/forums/stats`, config);

export const FORUMS_KEY = `forums`;
export const FORUMS_LIST_FOR_MOVE_TOPIC_KEY = `forums-list-for-move-topic`;

export const FORUM_CHILDRENS_KEY = `forum-childrens`;
export const FORUM_TOPICS_KEY = `forum-topics`;
export const FORUM_STATS_KEY = `forum-stats`;

export const FORUM_BREADCRUMBS_KEY = `forum-breadcrumbs`;

export const FORUM_TOPIC_COMMENTS_KEY = `forum-topic-comments`;
export const FORUM_TOPIC_COMMENT_KEY = `forum-topic-comment`